import { TranslateService } from '@ngx-translate/core';
import { Station } from './station.model';
import { ConnectorModel } from './connector-model.model';
import { StationAccessType } from './station-access-type.model';
import { StationState } from './station-state.model';
import { GroupModel } from './group-model.model';
import { Image } from './image.model';

export class StationModel {
  StationId: string;
  Name: string;
  State: string;
  StateText: string;
  Address: string;
  Latitude: number;
  Longitude: number;
  AccessType: StationAccessType;
  AccessTypeText: string;
  EnergyPrice: number;
  EnergyPriceText: string;
  ParkingPrice: number;
  ParkingPriceText: string;
  Edit: string;
  Description: string;
  Connectors: ConnectorModel[];
  Data: Station;
  GroupModel: GroupModel;
  SearchString: string;
  Images: Image[];
  ActivePower: number;
  AllowEditing: boolean;
  IsDisabled: boolean;

  constructor(private station: Station, public translate: TranslateService) {
    this.Data = station;
    this.Connectors = new Array<ConnectorModel>();
    this.initValues();
    this.buildSearchString();
  }

  private initValues() {
    this.StationId = this.Data.ID;
    this.Name = this.Data.Name;
    this.Address = this.Data.Address;
    this.Latitude = this.Data.Latitude;
    this.Longitude = this.Data.Longitude;
    this.Description = this.Data.Description;
    this.IsDisabled = this.Data.IsDisabled;
    this.Images = this.Data.Images;
    this.ActivePower = this.Data.ActivePower;
    this.AllowEditing = this.Data.CanBeManaged;
    this.State = StationState[this.Data.State];

    if (this.Connectors.length === 0) {
      let connectorCount = 1;
      this.Data.Connectors.forEach((connector) => {
        const connectorModel = new ConnectorModel(
          connector,
          this.StationId,
          this.translate
        );
        connectorModel.AllowEditing = this.AllowEditing;
        if (connectorCount === this.Data.Connectors.length) {
          connectorModel.IsLastConnector = true;
        } else {
          connectorModel.IsLastConnector = false;
        }
        this.Connectors.push(connectorModel);
        connectorCount++;
      });
    } else {
      this.Connectors.forEach((connector) => {
        connector.discardChanges();
      });
    }

    if (this.Connectors.length === 1) {
      const con = this.Connectors[0];

      this.AccessType = con.Data.AccessType;
      this.translate
        .get(StationAccessType[con.Data.AccessType])
        .subscribe((res: string) => {
          this.AccessTypeText = res;
        });

      this.EnergyPrice = con.EnergyPrice;
      this.EnergyPriceText = con.EnergyPriceText;
      this.ParkingPrice = con.ParkingPrice;
      this.ParkingPriceText = con.ParkingPriceText;
      this.translate
        .get(StationState[con.Data.State])
        .subscribe((res: string) => {
          this.StateText = res;
        });
    }
  }

  public buildSearchString() {
    let searchString = this.Name;
    searchString += this.Address;
    searchString += this.AccessTypeText;
    searchString += this.EnergyPriceText;
    searchString += this.ParkingPriceText;
    searchString += this.Description;
    searchString += this.StateText;
    this.Connectors.forEach((connector) => {
      searchString += connector.Name;
      searchString += connector.AccessTypeText;
      searchString += connector.EnergyPriceText;
      searchString += connector.ParkingPriceText;
      searchString += connector.Description;
      searchString += connector.StateText;
    });

    this.SearchString = searchString;

    this.Connectors.forEach((connector) => {
      connector.SearchString = searchString;
    });

    if (this.GroupModel !== undefined && this.GroupModel !== null) {
      this.GroupModel.buildSearchString();
    }
  }

  public discardChanges() {
    this.initValues();
  }
}
